<script>
import { mapState, mapGetters } from 'vuex';
import dateMixin from '../../mixins/dateMixin';
import Wrapper from './ReminderRuleSettingTypes/Wrapper';
import utility from '../../mixins/utility';

export default {
  name: 'ReminderRulesSettings',
  mixins: [
    dateMixin,
    utility,
  ],
  components: {
    Wrapper,
  },
  data() {
    return {
      item: undefined,
      actionType: undefined,
      show: false,
      search: undefined,
      searchType: 'all',
      showInactive: false,
      focus: undefined,
      pagination: {
        rowsPerPage: 25,
      },
    };
  },
  computed: {
    ...mapState({
      list: state => state.reminders.rules.settings.list,
      domain: state => state.reminders.rules.domain,
    }),
    ...mapGetters({
      settingHeaders: 'reminders/getSettingHeaders',
      exceptionTypes: 'reminders/getGlobalExceptionTypes',
    }),
    settings() {
      return this.list.items.filter((item) => {
        if (!this.showInactive && item.deletedAt) {
          return false;
        }

        if (this.searchType !== 'all') {
          return item.type === this.searchType;
        }

        if (!this.search) {
          return true;
        }

        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
      });
    },
    allExceptionTypes() {
      return [
        { value: 'all', text: 'All' },
      ].concat(this.exceptionTypes);
    },
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    add() {
      this.focus = undefined;
      this.item = {
        name: undefined,
        comment: undefined,
        type: 'date',
        data: undefined,
      };
      this.actionType = 'create';
      this.show = true;
    },
    update(item) {
      this.focus = item.id;
      this.item = item;
      this.actionType = 'update';
      this.show = true;
    },
    close() {
      this.show = false;
      this.item = undefined;
      this.actionType = undefined;
    },
  },
};
</script>

<template>
  <div>
    <v-layout row mt-3>
      <v-flex shrink>
        <span class="headline font-weight-bold">
          Exceptions
        </span>
      </v-flex>
      <v-flex shrink ml-2>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="pt-1">info</v-icon>
          </template>
          <span>
              Apply a global exception for this domain
              <br>
              <br>
              You can modify an already created exception by clicking on a row
            </span>
        </v-tooltip>
      </v-flex>
      <v-spacer/>
      <v-flex shrink>
        <v-btn color="info"  @click="add">Create New</v-btn>
      </v-flex>
    </v-layout>

    <v-divider/>

    <v-layout row mt-2>
      <v-flex md2 xs4>
        <v-text-field
          v-model="search"
          label="Search By Name"
          clearable
          hide-details
        />
      </v-flex>
      <v-flex md2 xs4 pl-4>
        <v-select
          v-model="searchType"
          :items="allExceptionTypes"
          label="Search by type"
        />
      </v-flex>
      <v-flex md2 xs4 pl-4>
        <v-checkbox
          v-model="showInactive"
          label="Show Inactive"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-data-table
          :items="settings"
          :headers="settingHeaders"
          :loading="list.loading"
          :pagination.sync="pagination"
          dense
        >
          <template v-slot:no-data>
            <div v-if="list.items.length === 0 && !list.loading" class="text-xs-center grey--text font-italic">
              No exceptions found
            </div>
            <div v-else-if="list.items.length === 0" class="text-xs-center grey--text font-italic">
              Loading exceptions
            </div>
            <div v-else class="text-xs-center grey--text font-italic">
              No exceptions matched your search
            </div>
          </template>
          <template v-slot:items="props">
            <tr
              :class="{
                'grey lighten-3': props.item.deletedAt && props.item.id !== focus,
                'blue lighten-5': props.item.id === focus
              }"
              class="cursor-pointer"
              @click="update(props.item)"
            >
              <td>{{ props.item.name }}</td>
              <td class="text-capitalize">{{ props.item.type }}</td>
              <td>
                <template v-if="props.item.data">
                <span v-if="props.item.data === 'invalid'">
                  <span class="grey--text font-italic">Invalid Setting</span>
                </span>
                  <template v-else>
                    <span v-for="(value, key) in props.item.data" v-if="value" :key="key" class="pr-2">
                      <span class="font-weight-bold">{{ key | capitalizeFirstLetter }}: </span>
                      <span class="font-italic">{{ value | capitalizeFirstLetter }}</span>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <span class="grey--text font-italic">No data</span>
                </template>
              </td>
              <td>{{ props.item.user.firstName }} {{ props.item.user.lastName }}</td>
              <td>{{ formatDate(props.item.updatedAt) }}</td>
              <td>
                <span v-if="props.item.deletedAt" class="error--text">Inactive</span>
                <span v-else class="green--text">Active</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <wrapper
          v-if="show"
          :item="item"
          :action-type="actionType"
          @close="close"
        />
      </v-flex>
    </v-layout>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderRulesSettings.vue